<!-- 推广账户管理 - VIVO -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index"
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
		<div v-show="content_type == 0" class="screen-box">
			<div class="screen-label">推广账户名称</div>
			<a-input v-model="r_advertiser_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		<div v-show="content_type == 1" class="screen-box">
			<div class="screen-label">开发者账户名称</div>
			<a-input v-model="r_advertiser_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
	
		<a-button  v-show="content_type == 0" @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增推广账户</a-button>
		<a-button  v-show="content_type == 1" @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增开发者账户</a-button>
	</div>
	
	<div v-show="content_type == 0">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 推广账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.advertiser_name}}
			</div>
			<!-- 推广账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.advertiser_id}}
			</div>
			<!-- 公司名称 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.company_name}}
			</div>
			<!-- 数据源ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.source_id}}
			</div>
			
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				设置数据源ID
			</div>
		</div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<div v-show="content_type == 1">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width_d + 'px'}">
			<div  v-for="(item,index) in rableTitleDDD" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowDataDDD" :key="index" class="table-td"  :style="{'width': table_scroll_width_d + 'px'}">
			<!-- 推广账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitleDDD[0].width + 'px'}">
				{{item.account_name}}
			</div>
			<!-- 推广账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[1].width + 'px'}">
				{{item.account_id}}
			</div>
			
			<!-- 操作 -->
			<div class="table-td-cell" :style="{'width': rableTitleDDD[2].width + 'px'}" style="display: flex;align-items: center;">
				<div @click="editDevTable(index,item)" style="color: #62a8ea;cursor: pointer;">编辑</div>
				<div @click="YYGL(index,item)" style="color: #62a8ea;cursor: pointer;margin-left: 15px;">应用管理</div>
			</div>
		</div>
		
		<div v-show="tableShowDataDDD.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width_d + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<!-- <div style="text-align: center;margin-top: 30px;" :style="{'width': table_scroll_width_d + 'px'}">
			
			<a-pagination v-model="d_page" :pageSize="20" :total="table_total_ddd" @change="paginationChange" />
			
		</div> -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="d_page" :r_limit="d_limit" :table_total="table_total_ddd"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      title="设置数据源ID"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
		<a-input v-model="e_source_id" placeholder="请输入数据源ID" style="width: 360px;"  />
	</a-modal>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="`${drawer_title}开发者账户`"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="drawer_visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			
			<div class="form-cell-box">
				<div class="class-title">开发者账户名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_account_name" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">开发者账户ID<span class="required-hint">*</span></div>
					
				<a-input v-model="x_account_id" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 应用管理 -->
	<a-drawer
	  title="应用管理"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="yygl_visible"
	  @close="onCloseYYGL"
	>
		<div style="">
			<!-- 表头 -->
			<div class="table-th">
				<div  v-for="(item,index) in rableTitleYYGL" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowDataYYGL" :key="index" class="table-td" >
				<!-- 应用名称 -->
				<div class="table-td-cell" :style="{'width':rableTitleYYGL[0].width + 'px'}">
					{{item.client_name}}
				</div>
				<!-- Client_id -->
				<div  class="table-td-cell" :style="{'width':rableTitleYYGL[1].width + 'px'}">
					{{item.client_id}}
				</div>
				<!-- Secret -->
				<div  class="table-td-cell" :style="{'width':rableTitleYYGL[2].width + 'px'}">
					{{item.secret}}
				</div>
			</div>
			
			<div v-show="tableShowDataYYGL.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { accountVivoAdvList, setVivoAdvSource, accountVivoDevList, accountVivoDevEdit, accountVivoDevAdd, accountVivoApplicationList } from '@/request/api'
export default {
	name: 'accountVIVO_',
	components: {
		
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			r_advertiser_name: "", // 推广账户名称
			r_account_name: "", // 开发者账户名称
			r_page: 1,
			r_limit: 100,
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广账户名称", width:180, type:"advertiser_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广账户ID", width:240, type:"advertiser_id", },
				{title:"公司名称", width:180, type:"company_name", },
				{title:"数据源ID", width:200, type:"source_id", },
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			table_scroll_width_d: 1000,
			search_button_loading: false,
			table_total: 0,
			
			rableTitleDDD: [
				{title:"推广账户名称", width:200, type:"advertiser_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广账户ID", width:260, type:"advertiser_id", },
				{title:"操作", width:160, type:"cz", },
			],
			tableShowDataDDD: [],
			table_total_ddd: 0,
			d_page: 1,
			d_limit: 100,
			
			edit_visible: false, // 设置数据源ID 弹窗显示控制
			confirmLoading: false, // 设置数据源ID 弹窗确认按钮的加载状态
			e_source_id: "", // 设置数据源ID 请求参数
			e_id: "",
			
			dev_click_number: 0, // 用于判断是否第一次点击
			
			add_form_hint: "",
			x_account_name: "",
			x_account_id: "",
			x_id: "",
			add_button_loading: false,
			drawer_title: "",
			drawer_visible: false,
			
			// 应用管理侧边栏
			yygl_visible: false,
			rableTitleYYGL: [
				{title:"应用名称", width:160, type:"client_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"Client_id", width:140, type:"client_id", },
				{title:"Secret", width:180, type:"secret", },
				// {title:"操作", width:160, type:"cz", },
			],
			tableShowDataYYGL: [],
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		let table_info_c = this.$getTableInfo(that.rableTitleDDD)
		that.table_scroll_width = table_info.table_width
		that.table_scroll_width_d = table_info.table_width
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		that.searchButton()
	},
	methods:{
		changeTab(e,index){
			let that = this
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				if(this.dev_click_number == 0 && e.label == "开发者账户管理"){
					this.r_page = 1
					that.searchButton()
					this.dev_click_number = this.dev_click_number + 1
				}
			}
			
		},
		// 搜索
		searchButton(type){
			let that = this
			
			that.search_button_loading = true
			
			if(that.content_type == 0){ // 推广账户管理
				if(type == 'button'){
					that.r_page = 1
				}
				accountVivoAdvList({
					limit: that.r_limit,
					page: that.r_page,
					advertiser_name: that.r_advertiser_name,
				}).then(res=>{
					console.log("推广账户管理",res);
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(that.content_type == 1){ // 开发者账户管理
				if(type == 'button'){
					that.d_page = 1
				}
				accountVivoDevList({
					limit: that.d_limit,
					page: that.d_page,
					account_name: that.r_account_name
				}).then(res=>{
					console.log("开发者账户管理",res);
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total_ddd = res.data.data.total
						that.tableShowDataDDD = res.data.data.data
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		addButton(){
			let that = this
			if(that.content_type == 0){ // 推广账户管理
				this.$confirm({
			        title: '添加推广账户',
			        content: "点击确认打开新网页进行授权，授权成功后请刷新页面",
					okText: '确认',
					cancelText: '取消',
			        onOk() {
			          window.open("https://open-ad.vivo.com.cn/OAuth?clientId=20211115002&state=zdxs771&redirectUri=https%3A%2F%2Fadmin-wx.ledu19.cn%2Fapi%2Fvivo%2Foauth%2Fcallback%2F1")
			        },
			        onCancel() {
			          console.log('Cancel');
			        },
			    });
				
				
			}
			else if(that.content_type == 1){
				this.drawer_title = "新增"
				this.drawer_visible = true
			}
		},
		// 分页
		paginationChange(e){
			let that = this
			if(that.content_type == 0){ // 推广账户管理
				this.r_page = e
			}
			else if(that.content_type == 1){ // 开发者账户管理
				that.d_page = e
			}
			that.searchButton()
			
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			
			if(that.content_type == 0){ // 推广账户管理
				this.r_limit = e
			}
			else if(that.content_type == 1){ // 开发者账户管理
				this.d_limit = e
			}
			this.searchButton('button')
		},
		
		
		// 设置数据源ID
		editTable(index,e){
			console.log(e);
			this.e_source_id = e.source_id, // 设置数据源ID 请求参数
			this.e_id = e.id,
			this.edit_visible = true
		},
		editModalOk(){
			let that = this
			this.confirmLoading = true
			setVivoAdvSource({
				id: that.e_id,
				source_id: that.e_source_id
			}).then(res=>{
				that.confirmLoading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.editModalCancel()
					that.$message.success('设置成功');
					that.searchButton()
					console.log("设置数据源ID",res);
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		editModalCancel(){
			if(this.confirmLoading){
				return
			}
			this.edit_visible = false
		},
		
		editDevTable(index,item){ // 编辑开发者账户
			console.log(item);
			this.drawer_title = "编辑"
			this.x_account_name = item.account_name
			this.x_account_id = item.account_id
			this.x_id = item.id
			this.drawer_visible = true
		},
		addRequest(){
			let that = this
			if(!that.x_account_name){
				that.add_form_hint = "请填写 开发者账户名称"
			}
			else if(!that.x_account_id){
				that.add_form_hint = "请填写 开发者账户ID"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					accountVivoDevAdd({
						account_name: that.x_account_name,
						account_id: that.x_account_id
					}).then(res=>{
						that.add_button_loading = false
						console.log("新增",res);
						that.onCloseDrawer()
						that.$message.success('新增成功');
						that.searchButton()
					})
				}
				else if(that.drawer_title == "编辑"){
					accountVivoDevEdit({
						id: that.x_id,
						account_name: that.x_account_name,
						account_id: that.x_account_id,
					}).then(res=>{
						that.add_button_loading = false
						console.log('编辑',res);
						that.onCloseDrawer()
						that.$message.success('编辑成功');
						that.searchButton()
					})
				}
				
			}
		},
		onCloseDrawer(){
			let that = this
			if(this.add_button_loading){
				return
			}
			that.x_account_name = ""
			that.x_account_id = ""
			that.add_form_hint = ""
			this.drawer_visible = false
		},
		
		// 应用管理
		YYGL(index,e){
			console.log(e);
			let that = this
			that.search_button_loading = true
			accountVivoApplicationList({
				limit: 2000,
				page: 1,
				account_id: e.id
			}).then(res=>{
				console.log("应用管理",res);
				that.search_button_loading = false
				that.tableShowDataYYGL = res.data.data.data
				that.yygl_visible = true
			})
			
		},
		onCloseYYGL(){
			this.yygl_visible = false
		},
	}
}
</script>

<style>
.class-title {
	width: 100px;
}

</style>